<template>
  <div class="flex flex-col gap-md text-on-background">
    <div class="flex gap-md">
      <OrSelectV3
        v-model="value.period"
        class="w-1/4"
        :label="$t('monitoringModal.period')"
        :options="periodOptions"
        @update:modelValue="onUpdatePeriod"
      />
      <OrSelectV3
        v-model="value.scale"
        class="w-1/4"
        :label="$t('monitoringModal.scale')"
        :options="scaleOptions"
        @update:modelValue="onUpdateScale"
      />
    </div>
    <monitoring-table
      v-if="!isLoading"
      :metric-data="metricData"
    />
    <div v-if="isLoading">
      <OrSkeletonTextV3
        :font-size="16"
        :line-height="50"
        :lines-count="5"
        animated
      />
    </div>
  </div>
</template>
<script lang="ts">

import { defineComponent, PropType } from 'vue';
import { MetricData } from '../../types';
import { OrSelectV3, OrSkeletonTextV3 } from '@onereach/ui-components';
import MonitoringTable from './MonitoringTable.vue';
import { PERIODS_MONITORING, SCALE_MONITORING, SCALE_MONITORING_FOR_1_HOUR, SCALE_MONITORING_FOR_HOURS, SCALE_MONITORING_FOR_3_HOURS } from '../../constants';
import _ from 'lodash';

export default defineComponent({
  name: 'QueueMonitoringForm',
  components: {
    MonitoringTable,
    OrSelectV3,
    OrSkeletonTextV3,
  },
  props: {
    metricData: {
      type: Array as PropType<MetricData[]>,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ['updateParams'],
  data() {
    return {
      value: {
        period: 'Last 1 hour',
        scale: '15 min',
      },
      periodOptions: _.map(PERIODS_MONITORING, (item) => ({
        value: item,
        label: item,
      })),
      scaleOptions: _.map(SCALE_MONITORING_FOR_1_HOUR, (item) => ({
        value: item,
        label: item,
      })),
    };
  },
  methods: {
    async onUpdatePeriod(): Promise<void> {
      this.changeScaleOptions();
      this.changeScale();
      this.$emit('updateParams', this.value);
    },
    async onUpdateScale(): Promise<void> {
      this.$emit('updateParams', this.value);
    },
    changeScale(): void {
      switch (this.value.period) {
        case 'Last 1 hour':
          this.value.scale = '15 min';
          break;
        case 'Last 3 hours':
          this.value.scale = '30 min';
          break;
        case 'Last 6 hours':
          this.value.scale = '1 hour';
          break;
        case 'Last 12 hours':
        case 'Last 24 hours':
          this.value.scale = '3 hours';
          break;
        case 'Last 3 days':
        case 'Last 1 week':
        case 'Last 2 weeks':
          this.value.scale = '1 day';
          break;
        default:
          return;
      }
    },
    changeScaleOptions(): void {
      let options = [];
      switch (this.value.period) {
        case 'Last 1 hour':
          options = SCALE_MONITORING_FOR_1_HOUR;
          break;
        case 'Last 3 hours':
          options = SCALE_MONITORING_FOR_3_HOURS;
          break;
        case 'Last 6 hours':
        case 'Last 12 hours':
        case 'Last 24 hours':
          options = SCALE_MONITORING_FOR_HOURS;
          break;
        case 'Last 3 days':
        case 'Last 1 week':
        case 'Last 2 weeks':
          options = SCALE_MONITORING;
          break;
        default:
          return;
      }
      this.scaleOptions = _.map(options, (item) => ({
        value: item,
        label: item,
      }));
    },
  },
});
</script>
